import type { FC } from "react";
import type { SessionEducationalResourceItem } from "../../interfaces/sessionDetails";
import { SessionResourceList } from "./SessionResourceList";

type SessionHandoutsSectionProps = {
  items: SessionEducationalResourceItem[];
};

export const SessionHandoutsSection: FC<SessionHandoutsSectionProps> = ({
  items,
}) => (
  <SessionResourceList
    titleKey="session_handouts"
    titleFallback="Handouts"
    items={items}
    emptyKey="session_no_handouts"
    emptyFallback="No handouts for this session."
  />
);
